module.exports = __webpack_public_path__ + "r.no2.a1104567.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/r.no2.jpg
// module id = cdyz
// module chunks = 0